export const ROLES_FIELD_NAME = 'roles';

export const TEST_ID = 'userFormFields';
